/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createXgcd } from '../../factoriesAny.js';
export var xgcdDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createXgcd: createXgcd
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesXgcd.generated.js
// module id = 1685
// module chunks = 0